import Link from 'next/link';

const alphabet = `abcdefghijklmnopqrstuvwxyz'0123456789`.split('');

function AlphabetLinkList({ type }) {
  return (
    <ul className="o-layout o-layout--gutter-small u-margin-bottom-large">
      {alphabet.map(letter => (
        <li key={letter} className="o-layout__cell o-layout__cell--fit">
          <Link
            href={`/bladeren/${type}/${letter}`}
            className="u-text-uppercase"
          >
            {letter}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default AlphabetLinkList;
